import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorFraudeModalComponent } from './error-fraude-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorFraudeModalService {
  private opened = false;

  constructor(private dialog: MatDialog) {}

  openDialog(title?: string, desc?: string): void {
    if (!this.opened) {
      this.opened = true;
      const dialogRef = this.dialog.open(ErrorFraudeModalComponent, {
        width: '700px',
        maxWidth: '750px',
        data: {
          description: desc,
          title: title,
        },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
    }
  }
}
